import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Delete extends Component  {

  @observable trans = { };

  constructor(props) {
    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  render() {

    const t = this.t;

    return (
      <div className={"Delete " + (this.props.dingsPosition ? 'Delete-'+this.props.dingsPosition : '')}>
        <button onClick={ ()=> { this.props.onDelete() } } className="Delete-delete">{t('Delete')}</button>
        <button onClick={ ()=> { this.props.onCancel() } }  className="Delete-cancel">{t('Cancel')}</button>
      </div>
    );
  }
}


